"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { SingleWaveDropClose } from "./SingleWaveDropClose";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { SingleWaveDropTab } from "./SingleWaveDrop";
import { ApiWave } from "@/generated/models/ApiWave";
import { SingleWaveDropInfoContainer } from "./SingleWaveDropInfoContainer";
import { SingleWaveDropInfoDetails } from "./SingleWaveDropInfoDetails";
import { SingleWaveDropInfoAuthorSection } from "./SingleWaveDropInfoAuthorSection";
import { SingleWaveDropInfoActions } from "./SingleWaveDropInfoActions";
import { SingleWaveDropPosition } from "./SingleWaveDropPosition";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AnimatePresence, motion } from "framer-motion";
import { SingleWaveDropVotes } from "./SingleWaveDropVotes";
import { faCompress } from "@fortawesome/free-solid-svg-icons";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import { WinnerBadge } from "./WinnerBadge";
import { SingleWaveDropTraits } from "./SingleWaveDropTraits";
import { ApiDropType } from "@/generated/models/ApiDropType";
import WaveDropDeleteButton from "@/components/utils/button/WaveDropDeleteButton";
import { ImageScale } from "@/helpers/image.helpers";
interface MemesSingleWaveDropInfoPanelProps {
  readonly drop: ExtendedDrop;
  readonly wave: ApiWave | null;
  readonly activeTab: SingleWaveDropTab;
  readonly onClose: () => void;
}
export const MemesSingleWaveDropInfoPanel: React.FC<MemesSingleWaveDropInfoPanelProps> = t0 => {
  const $ = _c(69);
  const {
    drop,
    wave,
    activeTab,
    onClose
  } = t0;
  const [isFullscreen, setIsFullscreen] = useState(false);
  const {
    isWinner,
    canDelete
  } = useDropInteractionRules(drop);
  let t1;
  if ($[0] !== drop.metadata || $[1] !== drop.title) {
    t1 = drop.metadata?.find(_temp)?.data_value ?? drop.title ?? "Artwork Title";
    $[0] = drop.metadata;
    $[1] = drop.title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const title = t1;
  let t2;
  if ($[3] !== drop.metadata) {
    t2 = drop.metadata?.find(_temp2)?.data_value ?? "";
    $[3] = drop.metadata;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const description = t2;
  let t3;
  if ($[5] !== drop.parts) {
    t3 = drop.parts?.at(0)?.media?.at(0);
    $[5] = drop.parts;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const artworkMedia = t3;
  let t4;
  if ($[7] !== isFullscreen) {
    t4 = e => {
      e.preventDefault();
      e.stopPropagation();
      setIsFullscreen(!isFullscreen);
    };
    $[7] = isFullscreen;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const toggleFullscreen = t4;
  let t5;
  if ($[9] !== onClose) {
    t5 = <div className="tw-hidden lg:tw-block"><SingleWaveDropClose onClose={onClose} /></div>;
    $[9] = onClose;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== drop.drop_type || $[12] !== drop.rank) {
    t6 = drop?.drop_type === ApiDropType.Participatory && <SingleWaveDropPosition rank={drop.rank} />;
    $[11] = drop.drop_type;
    $[12] = drop.rank;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== drop || $[15] !== isWinner) {
    t7 = isWinner && <WinnerBadge drop={drop} showBadge={true} />;
    $[14] = drop;
    $[15] = isWinner;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <div className="tw-px-6 tw-pb-3">{t6}{t7}</div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== title) {
    t9 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-x-3 tw-px-6"><h3 className="tw-text-lg tw-font-semibold tw-text-iron-100 tw-mb-0">{title}</h3></div>;
    $[20] = title;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== description) {
    t10 = description && <div className="tw-px-6 tw-mt-2"><p className="!tw-text-iron-400 tw-text-md tw-mb-0">{description}</p></div>;
    $[22] = description;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== artworkMedia) {
    t11 = artworkMedia && <div className="tw-flex tw-justify-center tw-h-96"><DropListItemContentMedia media_mime_type={artworkMedia.mime_type} media_url={artworkMedia.url} isCompetitionDrop={true} imageScale={ImageScale.AUTOx1080} /></div>;
    $[24] = artworkMedia;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== drop) {
    t12 = <div className="tw-px-6 tw-mt-4"><SingleWaveDropTraits drop={drop} /></div>;
    $[26] = drop;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== drop) {
    t13 = <div className="tw-px-6 tw-mt-4"><SingleWaveDropVotes drop={drop} /></div>;
    $[28] = drop;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== drop || $[31] !== wave) {
    t14 = <div className="tw-px-6 tw-mt-4"><SingleWaveDropInfoAuthorSection drop={drop} wave={wave} /></div>;
    $[30] = drop;
    $[31] = wave;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== drop) {
    t15 = <SingleWaveDropInfoActions drop={drop} />;
    $[33] = drop;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t11 || $[36] !== t12 || $[37] !== t13 || $[38] !== t14 || $[39] !== t15) {
    t16 = <div className="tw-mt-4">{t11}{t12}{t13}{t14}{t15}</div>;
    $[35] = t11;
    $[36] = t12;
    $[37] = t13;
    $[38] = t14;
    $[39] = t15;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== drop) {
    t17 = <SingleWaveDropInfoDetails drop={drop} />;
    $[41] = drop;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== canDelete || $[44] !== drop) {
    t18 = canDelete && drop.drop_type !== ApiDropType.Winner && <div className="tw-border-t tw-border-iron-800 tw-border-solid tw-border-x-0 tw-border-b-0 tw-pt-4 tw-px-6 tw-pb-6"><WaveDropDeleteButton drop={drop} /></div>;
    $[43] = canDelete;
    $[44] = drop;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t10 || $[47] !== t16 || $[48] !== t17 || $[49] !== t18 || $[50] !== t8 || $[51] !== t9) {
    t19 = <div className="tw-flex tw-flex-col">{t8}{t9}{t10}{t16}{t17}{t18}</div>;
    $[46] = t10;
    $[47] = t16;
    $[48] = t17;
    $[49] = t18;
    $[50] = t8;
    $[51] = t9;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  let t20;
  if ($[53] !== activeTab || $[54] !== t19 || $[55] !== t5) {
    t20 = <SingleWaveDropInfoContainer activeTab={activeTab}>{t5}{t19}</SingleWaveDropInfoContainer>;
    $[53] = activeTab;
    $[54] = t19;
    $[55] = t5;
    $[56] = t20;
  } else {
    t20 = $[56];
  }
  let t21;
  if ($[57] !== artworkMedia || $[58] !== description || $[59] !== drop || $[60] !== isFullscreen || $[61] !== title || $[62] !== toggleFullscreen) {
    t21 = isFullscreen && artworkMedia && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="tw-fixed tw-inset-0 tw-z-50 tw-bg-iron-950/90 tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-4"><div className="tw-w-full tw-max-w-5xl tw-flex tw-justify-between tw-items-center tw-mb-4"><div className="tw-flex tw-flex-col"><div className="tw-flex tw-items-center tw-gap-x-3"><SingleWaveDropPosition rank={drop.rank ?? 1} drop={drop} /><h3 className="tw-text-xl tw-font-semibold tw-text-iron-100">{title}</h3></div>{description && <p className="tw-text-iron-400 tw-text-md tw-mt-1 tw-ml-10">{description}</p>}</div><div className="tw-mx-auto"><SingleWaveDropVotes drop={drop} /></div><button onClick={toggleFullscreen} className={"tw-bg-iron-900/80 tw-text-iron-100 tw-p-3 tw-rounded-lg \n                        tw-transition-colors tw-duration-200 hover:tw-bg-iron-800 \n                        focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-primary-400"} aria-label="Exit fullscreen view"><FontAwesomeIcon icon={faCompress} className="tw-w-5 tw-h-5" /></button></div><div className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center"><img src={artworkMedia.url} alt={title} className="tw-max-w-full tw-max-h-full tw-object-contain" /></div></motion.div>;
    $[57] = artworkMedia;
    $[58] = description;
    $[59] = drop;
    $[60] = isFullscreen;
    $[61] = title;
    $[62] = toggleFullscreen;
    $[63] = t21;
  } else {
    t21 = $[63];
  }
  let t22;
  if ($[64] !== t21) {
    t22 = <AnimatePresence>{t21}</AnimatePresence>;
    $[64] = t21;
    $[65] = t22;
  } else {
    t22 = $[65];
  }
  let t23;
  if ($[66] !== t20 || $[67] !== t22) {
    t23 = <>{t20}{t22}</>;
    $[66] = t20;
    $[67] = t22;
    $[68] = t23;
  } else {
    t23 = $[68];
  }
  return t23;
};
function _temp(m) {
  return m.data_key === "title";
}
function _temp2(m_0) {
  return m_0.data_key === "description";
}